import { CSVLink } from "react-csv";
import PropTypes from "prop-types";
import IconToSolve from "./icon";

const CSVButton = ({ data, filename }) => {
  return (
    <CSVLink data={data} filename={filename}>
      <IconToSolve
        className={"btn-table pt-2"}
        iconName={"Csv"}
        width={35}
        height={35}
      />{" "}
    </CSVLink>
  );
};

CSVButton.propTypes = {
  filename: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
};
export default CSVButton;
